<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>
      Eksport af handlingslogs
    </mat-panel-title>
  </mat-expansion-panel-header>
  @if (form.disabled) {
    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1em" class="settings-view">
      <dl fxFlex="45" class="settings-list">
        <dt>Eksport af handlingslogs</dt>
        <dd><span class="exports_enabled">{{value.exports_enabled ? 'Ja' : 'Nej'}}</span></dd>
      </dl>
      <p>
        Mulighed for at eksportere sagsrelaterede handlingslogs, fx "læs ansøgning" eller "ekspederet udbetaling",
        for en gruppe af brugere til et eksternt overvågningscenter (Security Operations Center, SOC).
      </p>
      @if (value.exports_enabled) {
        <mat-divider [vertical]="true"></mat-divider>
        <dl fxFlex=45 class="settings-list">
          <dt>SFTP-host:</dt>
          <dd>{{value.sftp_host}}</dd>
          <dt>SFTP-bruger:</dt>
          <dd>{{value.sftp_user}}</dd>
          <dt>SFTP-adgangskode:</dt>
          <dd>{{value.sftp_password}}</dd>
          <dt>SFTP-sti:</dt>
          <dd>{{value.sftp_path}}</dd>
          <dt>Bruger-filtrering</dt>
          <dd>{{ value.providers ? value.providers.join(', ') : 'Nej' }}</dd>
        </dl>
      }
    </div>
  }
  @if (form.enabled) {
    <form [formGroup]="form">
      <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1em" >
        <div fxFlex="45">
          <div fxLayout="column" class="mb-3">
            <mat-checkbox ngDefaultControl class="mb-3" fxFill formControlName="exports_enabled" (change)="onExportsEnabledChange()">Eksporter handlingslogs.</mat-checkbox>
          </div>
          @if (exportsEnabled) {
            <div fxLayout="column" class="mb-3">
              <label>SFTP-host</label>
              <mat-form-field>
                <input type="text" matInput formControlName="sftp_host">
                <mat-hint>Navnet på den SFTP-server, som handlingsloggen skal eksporteres til.</mat-hint>
                @if (form.controls['sftp_host'].hasError('required')) {
                  <mat-error>Obligatorisk.</mat-error>
                }
              </mat-form-field>
            </div>
            <div fxLayout="column" class="mb-3">
              <label>SFTP-bruger</label>
              <mat-form-field>
                <input type="text" matInput formControlName="sftp_user">
                <mat-hint>Login/kontonavn på SFTP-serveren.</mat-hint>
                @if (form.controls['sftp_user'].hasError('required')) {
                  <mat-error>Obligatorisk.</mat-error>
                }
              </mat-form-field>
            </div>
            <div fxLayout="column" class="mb-3">
              <label>SFTP-adgangskode</label>
              <mat-form-field>
                <input type="password" matInput formControlName="sftp_password" autocomplete="false">
                <mat-hint>Adgangskode for SFTP-brugeren.</mat-hint>
                @if (form.controls['sftp_password'].hasError('required')) {
                  <mat-error>Obligatorisk.</mat-error>
                }
              </mat-form-field>
            </div>
            <div fxLayout="column" class="mb-3">
              <label>SFTP-sti</label>
              <mat-form-field>
                <input type="text" matInput formControlName="sftp_path">
                <mat-hint>Sti til placering af filer på SFTP-serveren.</mat-hint>
                @if (form.controls['sftp_path'].hasError('required')) {
                  <mat-error>Obligatorisk.</mat-error>
                }
              </mat-form-field>
            </div>
          }
        </div>
        <mat-divider [vertical]="true"></mat-divider>
        <div fxFlex="45">
          @if (exportsEnabled) {
            <div fxLayout="column" class="mb-3">
              <label>Bruger-filtrering</label>
              <mat-form-field class="mb-3" fxFill>
                <mat-select formControlName="providers" multiple>
                  <mat-option value="saml">Single Sign On</mat-option>
                  <mat-option value="mitid">MitID</mat-option>
                  <mat-option value="mitid_employee">MitID Erhverv</mat-option>
                  <mat-option value="otp">To-faktor (app)</mat-option>
                  <mat-option value="otp_sms">To-faktor (SMS)</mat-option>
                </mat-select>
                <mat-hint>Begrænse evt. eksport til specifikke brugertyper.</mat-hint>
              </mat-form-field>
            </div>
          }
        </div>
      </div>
    </form>
  }
  <mat-action-row>
    @if (form.disabled) {
      <button mat-flat-button class="action-edit" (click)="doEdit()">Rediger</button>
    }
    @if (form.enabled) {
      <div>
        <button mat-stroked-button class="action-cancel" (click)="doCancel()">Fortryd</button>
        <button mat-flat-button class="action-save" (click)="doSave()" [disabled]="form.invalid">Gem</button>
      </div>
    }
  </mat-action-row>
</mat-expansion-panel>
